module.exports = __webpack_public_path__ + "img/logo-blanco.6ed7d23f.svg";